/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/location';
import '../../agenda/agendasync';
import '../../common/time';
import '../../agenda/calendar';
import '../../bills/cart';
import '../../omg/model/orders';
import '../../timecards/time';
import '../../connect/v2/common/money';
import '../../connect/v2/catalog/resources/datatypes';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "appointments": {
        "nested": {
          "api": {
            "nested": {
              "Business": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "needsMobileOnboarding": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 7,
                    "rule": "optional"
                  },
                  "buyerPrepaymentMode": {
                    "type": ".squareup.agenda.Business.BuyerPrepaymentMode",
                    "id": 8,
                    "rule": "optional"
                  },
                  "noShowProtectionEnabled": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "noShowChargeType": {
                    "type": ".squareup.agenda.Business.NoShowChargeType",
                    "id": 10,
                    "rule": "optional"
                  },
                  "noShowPercentage": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "noShowFlatFee": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "noShowCutoffTime": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  },
                  "bookingSitesEnabled": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional"
                  },
                  "sendReminderSms": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional"
                  },
                  "sendReminderEmail": {
                    "type": "bool",
                    "id": 16,
                    "rule": "optional"
                  },
                  "reminderSmsLeadTime": {
                    "type": "int32",
                    "id": 17,
                    "rule": "optional"
                  },
                  "reminderEmailLeadTime": {
                    "type": "int32",
                    "id": 18,
                    "rule": "optional"
                  },
                  "reserveWithGoogleEnabled": {
                    "type": "bool",
                    "id": 19,
                    "rule": "optional"
                  },
                  "sendConfirmationSms": {
                    "type": "bool",
                    "id": 20,
                    "rule": "optional"
                  },
                  "sendConfirmationEmail": {
                    "type": "bool",
                    "id": 21,
                    "rule": "optional"
                  },
                  "confirmationLeadTime": {
                    "type": "uint32",
                    "id": 22,
                    "rule": "optional"
                  },
                  "conversationsEnabled": {
                    "type": "bool",
                    "id": 23,
                    "rule": "optional"
                  },
                  "locationTypeVideoCallEnabled": {
                    "type": "bool",
                    "id": 24,
                    "rule": "optional"
                  },
                  "cancellationPolicy": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  },
                  "depositsEnabled": {
                    "type": "bool",
                    "id": 26,
                    "rule": "optional"
                  },
                  "depositChargeType": {
                    "type": ".squareup.agenda.Business.DepositChargeType",
                    "id": 33,
                    "rule": "optional"
                  },
                  "depositAmountCents": {
                    "type": "int64",
                    "id": 34,
                    "rule": "optional"
                  },
                  "depositAmountPercentage": {
                    "type": "int32",
                    "id": 35,
                    "rule": "optional"
                  },
                  "depositCancellationFeeTaxEnabled": {
                    "type": "bool",
                    "id": 36,
                    "rule": "optional"
                  },
                  "depositCancellationFeeTaxPercentage": {
                    "type": "string",
                    "id": 37,
                    "rule": "optional"
                  },
                  "depositRefundPolicy": {
                    "type": "string",
                    "id": 38,
                    "rule": "optional"
                  },
                  "displayTextMarketingOptIn": {
                    "type": "bool",
                    "id": 39,
                    "rule": "optional"
                  },
                  "displayEmailMarketingOptIn": {
                    "type": "bool",
                    "id": 40,
                    "rule": "optional"
                  },
                  "buyerPrepaymentTippingEnabled": {
                    "type": "bool",
                    "id": 41,
                    "rule": "optional"
                  },
                  "requireCofWhenBooking": {
                    "type": "bool",
                    "id": 42,
                    "rule": "optional"
                  },
                  "marketplaceOnboardingState": {
                    "type": ".squareup.agenda.MarketplaceOnboardingStateScope.MarketplaceOnboardingState",
                    "id": 43,
                    "rule": "optional"
                  },
                  "scarcity": {
                    "type": "int32",
                    "id": 44,
                    "rule": "optional"
                  },
                  "displayCancellationPolicy": {
                    "type": "bool",
                    "id": 45,
                    "rule": "optional"
                  },
                  "multipleStaffBookingEnabled": {
                    "type": "bool",
                    "id": 46,
                    "rule": "optional"
                  },
                  "multipleServiceBookingEnabled": {
                    "type": "bool",
                    "id": 47,
                    "rule": "optional"
                  },
                  "maxReservationType": {
                    "type": ".squareup.agenda.MaxReservationTypeScope.MaxReservationType",
                    "id": 48,
                    "rule": "optional"
                  },
                  "maxReservationLimit": {
                    "type": "int32",
                    "id": 49,
                    "rule": "optional"
                  },
                  "locationType": {
                    "type": "string",
                    "id": 50,
                    "rule": "optional"
                  },
                  "cutoffTime": {
                    "type": "int32",
                    "id": 51,
                    "rule": "optional"
                  },
                  "restype": {
                    "type": "string",
                    "id": 52,
                    "rule": "optional"
                  },
                  "alignmentTime": {
                    "type": "int32",
                    "id": 53,
                    "rule": "optional"
                  },
                  "allowUserCancel": {
                    "type": "bool",
                    "id": 54,
                    "rule": "optional"
                  },
                  "futureBookingLimitTime": {
                    "type": "int32",
                    "id": 55,
                    "rule": "optional"
                  },
                  "anyStaffBookingEnabled": {
                    "type": "bool",
                    "id": 56,
                    "rule": "optional"
                  },
                  "skipObsStaffSelection": {
                    "type": "bool",
                    "id": 57,
                    "rule": "optional"
                  },
                  "customerCanSetBookingTimezone": {
                    "type": "bool",
                    "id": 58,
                    "rule": "optional"
                  },
                  "onlineBookingEnabled": {
                    "type": "bool",
                    "id": 59,
                    "rule": "optional"
                  },
                  "marketplaceEnabled": {
                    "type": "bool",
                    "id": 60,
                    "rule": "optional"
                  },
                  "qrCodeFormat": {
                    "type": ".squareup.agenda.QrCodeFormatScope.QrCodeFormat",
                    "id": 61,
                    "rule": "optional"
                  },
                  "serviceImagesEnabled": {
                    "type": "bool",
                    "id": 62,
                    "rule": "optional"
                  },
                  "categoriesEnabled": {
                    "type": "bool",
                    "id": 63,
                    "rule": "optional"
                  },
                  "categoryImagesEnabled": {
                    "type": "bool",
                    "id": 64,
                    "rule": "optional"
                  }
                }
              },
              "Appointment": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "staffId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "startDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "endDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "allDay": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "recurrenceRule": {
                    "type": ".squareup.agenda.RecurrenceRule",
                    "id": 8,
                    "rule": "optional"
                  },
                  "excludeDates": {
                    "type": ".squareup.agenda.TimestampList",
                    "id": 9,
                    "rule": "optional"
                  },
                  "parentId": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.agenda.AppointmentStatus",
                    "id": 11,
                    "rule": "optional",
                    "options": {
                      "default": "TEMPORARY"
                    }
                  },
                  "sellerNote": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "buyerNote": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "transitionTime": {
                    "type": "int64",
                    "id": 14,
                    "rule": "optional"
                  },
                  "locationType": {
                    "type": ".squareup.agenda.Appointment.LocationType",
                    "id": 15,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 16,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 18,
                    "rule": "optional"
                  },
                  "cart": {
                    "type": ".squareup.bills.Cart",
                    "id": 21,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int32",
                    "id": 22,
                    "rule": "optional"
                  },
                  "videoCallUrl": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "orderId": {
                    "type": "string",
                    "id": 24,
                    "rule": "optional"
                  },
                  "orderVersion": {
                    "type": "int32",
                    "id": 25,
                    "rule": "optional"
                  },
                  "reservationSegments": {
                    "type": ".squareup.appointments.api.ReservationSegment",
                    "id": 26,
                    "rule": "repeated"
                  },
                  "order": {
                    "type": ".squareup.omg.model.Order",
                    "id": 27,
                    "rule": "optional"
                  },
                  "creatorClientId": {
                    "type": "string",
                    "id": 19
                  },
                  "creatorStaffId": {
                    "type": "string",
                    "id": 20
                  }
                },
                "nested": {
                  "creator": {
                    "oneof": ["creatorClientId", "creatorStaffId"]
                  }
                }
              },
              "Confirmation": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reservationId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "reservationDateStart": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Event": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "staffId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "startDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "endDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 6,
                    "rule": "optional"
                  },
                  "allDay": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "recurrenceRule": {
                    "type": ".squareup.agenda.RecurrenceRule",
                    "id": 9,
                    "rule": "optional"
                  },
                  "excludeDates": {
                    "type": ".squareup.agenda.TimestampList",
                    "id": 10,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "parentId": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "availabilityType": {
                    "type": ".squareup.agenda.EventAvailabilityType",
                    "id": 13,
                    "rule": "optional",
                    "options": {
                      "default": "BUSY"
                    }
                  },
                  "notes": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "externalCalendarId": {
                    "type": "int32",
                    "id": 15,
                    "rule": "optional"
                  }
                }
              },
              "Client": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "firstName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "emailAddress": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "businessId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "smsNotificationsEnabled": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "emailNotificationsEnabled": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "notes": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "companyName": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "birthday": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 11,
                    "rule": "optional"
                  },
                  "cellphone": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 13,
                    "rule": "optional"
                  },
                  "externalSource": {
                    "type": ".squareup.agenda.ClientExternalSourceType",
                    "id": 14,
                    "rule": "optional",
                    "options": {
                      "default": "NOT_IMPORTED"
                    }
                  },
                  "externalReferenceId": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  }
                }
              },
              "Staff": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "firstName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "businessId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "userToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "smsNotificationsEnabled": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "emailNotificationsEnabled": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "iosNotificationsEnabled": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "hasPromptedToDisableSmsNotifications": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "deleted": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "colorScheme": {
                    "type": ".squareup.agenda.Staff.ColorScheme",
                    "id": 11,
                    "rule": "optional",
                    "options": {
                      "default": "BLUE"
                    }
                  },
                  "role": {
                    "type": ".squareup.agenda.Staff.Role",
                    "id": 12,
                    "rule": "optional",
                    "options": {
                      "default": "NO_ACCESS"
                    }
                  },
                  "personToken": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "zoomUserId": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  }
                }
              },
              "OpenTimeSlot": {
                "fields": {
                  "weekday": {
                    "type": ".squareup.agenda.Weekday",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startOffsetSeconds": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endOffsetSeconds": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "OpenTimes": {
                "fields": {
                  "openTimeSlots": {
                    "type": ".squareup.appointments.api.OpenTimeSlot",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "staffId": {
                    "type": "string",
                    "id": 1
                  },
                  "businessId": {
                    "type": "string",
                    "id": 2
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 4
                  }
                },
                "nested": {
                  "business_or_staff_or_unit": {
                    "oneof": ["staffId", "businessId", "unitToken"]
                  }
                }
              },
              "OpenHours": {
                "fields": {
                  "startDow0": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startDow1": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "startDow2": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "startDow3": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "startDow4": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "startDow5": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "startDow6": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "endDow0": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "endDow1": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "endDow2": {
                    "type": "int64",
                    "id": 10,
                    "rule": "optional"
                  },
                  "endDow3": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "endDow4": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "endDow5": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  },
                  "endDow6": {
                    "type": "int64",
                    "id": 14,
                    "rule": "optional"
                  }
                }
              },
              "AvailabilityOverride": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "employeeToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "availableRange": {
                    "type": ".squareup.timecards.LocalDateTimeRange",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "AppointmentsMerchant": {
                "fields": {
                  "bookingSitesEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "unitBookingSites": {
                    "type": ".squareup.appointments.api.UnitBookingSite",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "hasActiveSubscription": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "UnitBookingSite": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "bookingSiteUrl": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "onlineBookingEnabled": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "ReservationSegment": {
                "fields": {
                  "lineItemId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "teamMemberId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "resourceId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "serviceTimeSeconds": {
                    "type": "int32",
                    "id": 5,
                    "rule": "optional"
                  },
                  "intermissionStartOffsetSeconds": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "intermissionEndOffsetSeconds": {
                    "type": "int32",
                    "id": 7,
                    "rule": "optional"
                  },
                  "itemName": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "itemToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "itemVersion": {
                    "type": "int64",
                    "id": 10,
                    "rule": "optional"
                  },
                  "itemClientToken": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "itemVariationName": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "itemVariationToken": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "itemVariationVersion": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  },
                  "itemVariationClientToken": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "anyAvailableTeamMember": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "serviceCostOverrideMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 15,
                    "rule": "optional"
                  },
                  "defaultServiceCost": {
                    "type": ".squareup.connect.v2.merchant_catalog.resources.ServiceCost",
                    "id": 16,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Business && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Appointment && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Confirmation && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Event && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Client && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Staff && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OpenTimeSlot && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OpenTimes && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OpenHours && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.AvailabilityOverride && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.AppointmentsMerchant && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UnitBookingSite && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ReservationSegment) {
  $root.addJSON(jsonData);
}

/**
 * To generate protos after editing:
 * $ bundle exec rake sq:protos:compile
 * Business!
 *
 * SOURCE Business @ squareup/appointments/api/model.proto at 28:1
 */
export const Business = $root.lookupType('squareup.appointments.api.Business');
fixType(Business);
Builder.createAndAttachToType(Business);
/**
 * SOURCE Appointment @ squareup/appointments/api/model.proto at 208:1
 */
export const Appointment = $root.lookupType('squareup.appointments.api.Appointment');
fixType(Appointment);
Builder.createAndAttachToType(Appointment);
/**
 * Presence of a confirmation for an appointment occurrence indicates that the occurrence is confirmed.
 * It may seem excessive to have an entire model to represent a boolean state,
 * however, occurrences of recurring appointments can be confirmed,
 * which complicates this because the server only returns appointments not occurrences.
 *
 * SOURCE Confirmation @ squareup/appointments/api/model.proto at 286:1
 */
export const Confirmation = $root.lookupType('squareup.appointments.api.Confirmation');
fixType(Confirmation);
Builder.createAndAttachToType(Confirmation);
/**
 * An event is similar to an appointment, but just represents an available/busy slot, not an actual appointment.
 * These are read-only whereas appointments can be created and modified
 *
 * Client implementations of these should share an abstract superclass with Appointments so that the
 * rrule logic only need to be in one place
 *
 * SOURCE Event @ squareup/appointments/api/model.proto at 303:1
 */
export const Event = $root.lookupType('squareup.appointments.api.Event');
fixType(Event);
Builder.createAndAttachToType(Event);
/**
 * Represents a person. A customer of the service provider
 *
 * SOURCE Client @ squareup/appointments/api/model.proto at 341:1
 */
export const Client = $root.lookupType('squareup.appointments.api.Client');
fixType(Client);
Builder.createAndAttachToType(Client);
/**
 * A staff member of a business. Services can only be performed by specific staff members
 *
 * SOURCE Staff @ squareup/appointments/api/model.proto at 377:1
 */
export const Staff = $root.lookupType('squareup.appointments.api.Staff');
fixType(Staff);
Builder.createAndAttachToType(Staff);
/**
 * Represents a range of time when a business or staff is open
 *
 * SOURCE OpenTimeSlot @ squareup/appointments/api/model.proto at 480:1
 */
export const OpenTimeSlot = $root.lookupType('squareup.appointments.api.OpenTimeSlot');
fixType(OpenTimeSlot);
Builder.createAndAttachToType(OpenTimeSlot);
/**
 * All time ranges when a business or staff is open
 *
 * SOURCE OpenTimes @ squareup/appointments/api/model.proto at 489:1
 */
export const OpenTimes = $root.lookupType('squareup.appointments.api.OpenTimes');
fixType(OpenTimes);
Builder.createAndAttachToType(OpenTimes);
/**
 * Appointments hour format - represents when a business/staff is open.
 * Values are offsets in seconds from midnight.
 * Values > 86400 represent the next day, to allow for an hour that spans midnight.
 *
 * SOURCE OpenHours @ squareup/appointments/api/model.proto at 503:1
 */
export const OpenHours = $root.lookupType('squareup.appointments.api.OpenHours');
fixType(OpenHours);
Builder.createAndAttachToType(OpenHours);
/**
 * SOURCE AvailabilityOverride @ squareup/appointments/api/model.proto at 523:1
 */
export const AvailabilityOverride = $root.lookupType('squareup.appointments.api.AvailabilityOverride');
fixType(AvailabilityOverride);
Builder.createAndAttachToType(AvailabilityOverride);
/**
 * SOURCE AppointmentsMerchant @ squareup/appointments/api/model.proto at 550:1
 */
export const AppointmentsMerchant = $root.lookupType('squareup.appointments.api.AppointmentsMerchant');
fixType(AppointmentsMerchant);
Builder.createAndAttachToType(AppointmentsMerchant);
/**
 * SOURCE UnitBookingSite @ squareup/appointments/api/model.proto at 561:1
 */
export const UnitBookingSite = $root.lookupType('squareup.appointments.api.UnitBookingSite');
fixType(UnitBookingSite);
Builder.createAndAttachToType(UnitBookingSite);
/**
 * SOURCE ReservationSegment @ squareup/appointments/api/model.proto at 572:1
 */
export const ReservationSegment = $root.lookupType('squareup.appointments.api.ReservationSegment');
fixType(ReservationSegment);
Builder.createAndAttachToType(ReservationSegment);